module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921101151_T.6c4de4b2.jpg";